
import { defineComponent, ref, computed, watch } from "vue";
import { getIllustrationsPath } from "@/core/helpers/assets";
import { RegisteredCoursesRequest } from "@/core/endpoints/requests/earlyregisteredCourses_request";
import { RegisteredCoursesResponse } from "@/core/endpoints/responses/registeredCourses_response";
import { getCurrentInstance } from "vue";
import { UserInfoRequest } from "@/core/endpoints/requests/userInfo_request";
import { UserInfoResponse } from "@/core/endpoints/responses/userInfo_response";
import { boolean, number } from "yup/lib/locale";
import Swal from "sweetalert2/dist/sweetalert2.js";
import moment from "moment";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n/index";
import { bool } from "yup";

export default defineComponent({
  name: "widget-1",
  props: {
    widgetClasses: String,
    Sectionetails: [],
    CourseId: String,
    SceduleId: String,
    EnT_COURSE_PKG_DTL_ID: String,
    edStudCourseRegId: String,
    scscheduleDtlId: String,
    isReplace: Boolean,
  },
  setup(props) {
    const router = useRouter();

    const { t, te } = useI18n();
    const i18n = useI18n();
    const currentLanguage = i18n.locale.value;
    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };
    const sectionDetailsRes = ref<any>({});
    const sections = ref<any>(props.Sectionetails);
    //     const filteredSections = computed(() => {
    //   if (!sections.value) {
    //     return [];
    //   }
    // console.log(sectionDetailsRes.value);
    // console.log("*********----------------------------*********")

    //   if (isFull.value) {
    //     return sections.value.filter((section) => {
    //       const sectionDetail = sectionDetailsRes.value.sectionDetail.find(detail => detail.groupDescr.trim() === section.groupDescr.trim());
    //       return sectionDetail && sectionDetail.availableSeats === 0;
    //     });
    //   }

    //   if (isClash.value) {
    //     console.log(true)
    //     return sections.value.filter((section) => section.isClashed === false);
    //   }
    //  else if (!sectionDetailsRes.value || !sectionDetailsRes.value?.sectionDetail || sectionDetailsRes.value?.sectionDetail?.length === 0) {
    //     console.log(sections)
    //     console.log(sections)
    //     console.log(sections.value)
    //     console.log("**************************************************************")
    //     return sections;
    //   }

    //   return sections;
    // });
    const uniqueScheduleDays = computed(() => {
      const uniqueCombinations = new Set();
      return sectionDetailsRes.value.sectionDetail[0].scScheduleDays.filter(
        (scheduleDay) => {
          const combination = `${scheduleDay.campCode}_${scheduleDay.scBuildingDescr}_${scheduleDay.scHallDescr}`;
          if (!uniqueCombinations.has(combination)) {
            uniqueCombinations.add(combination);
            const { campCode, scBuildingDescr, scHallDescr } = scheduleDay;
            return { campCode, scBuildingDescr, scHallDescr, combination };
          }
        }
      );
    });
    const filteredSections = computed(() => {
      if (!sections.value) {
        return [];
      }

      //       if (isFull.value) {
      //   return sections.value.filter((section) => {
      //     const sectionDetail = sectionDetailsRes.value?.sectionDetail.find((detail) => detail.groupDescr.trim() === section.groupDescr.trim());

      //     return sectionDetail && sectionDetail.availableSeats > 0;
      //   });
      // }
      // if (!isFull.value) {
      //   return sections.value ;

      // }
      if (isFull.value) {
        return sections.value.filter(
          (section) => section.isFull === false && section.isClashed === false
        );
      } else if (isClash.value) {
        return sections.value.filter((section) => section.isClashed === false);
      } else {
        return sections.value;
      }
      // if (
      //   !sectionDetailsRes.value ||
      //   !sectionDetailsRes.value?.sectionDetail ||
      //   sectionDetailsRes.value?.sectionDetail?.length === 0
      // ) {
      //   return sections.value;
      // }
    });

    let registeredCoursesRequest = new RegisteredCoursesRequest();

    let isClash = ref(false);
    let isFull = ref(false);
    let selectedSection = ref(1);

    let userInfoRequest = new UserInfoRequest();
    const app = getCurrentInstance();
    let userinfo: any = {};
    let courseId: any = "";
    let edStudSemesterIdVal: any = "";

    let sceduleIdval: any = "";
    const loadSectionDetails = (id, sceduleId) => {
      sceduleIdval = sceduleId;

      const user = localStorage.getItem("userInfo") || "";
      const res = JSON.parse(user);
      userinfo = res;
      edStudSemesterIdVal = userinfo.earlyRegData.early_EdstudsemesterId;
      registeredCoursesRequest.EdStudSemesterId =
        userinfo.earlyRegData.early_EdstudsemesterId;

      registeredCoursesRequest.EdAcadYearId =
        userinfo.earlyRegData.early_YearId;
      registeredCoursesRequest.EdCourseId = id;
      registeredCoursesRequest.ScScheduleDtlId = sceduleId;
      registeredCoursesRequest.EdCodeSemesterID =
        userinfo.earlyRegData.early_EdCodeSemesterId;
      if (
        props.isReplace &&
        props.edStudCourseRegId != undefined &&
        props.isReplace == true
      ) {
        registeredCoursesRequest.ReplaceCourseId = props.edStudCourseRegId;
        if (props.scscheduleDtlId != undefined) {
          registeredCoursesRequest.ReplaceScSCheduleDtlId =
            props.scscheduleDtlId;
        }
      }
      if (props.edStudCourseRegId != undefined && props.isReplace == false) {
        registeredCoursesRequest.isUndrop = true;
      }
      registeredCoursesRequest.invokeGetSectionDetails(
        app,
        (me: any, registeredCoursesResponse: RegisteredCoursesResponse) => {
          if (registeredCoursesResponse) {
            sectionDetailsRes.value = registeredCoursesResponse;
          }
        }
      );
    };
    const formattedDate = (date) => {
      return date ? moment(date).format("h:mm A") : "";
    };
    const formattedDateTime = (date) => {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    };
    const noclash = () => {
      isClash.value;
      sectionDetailsRes.value = [];
      selectedSection.value = 1;

      filteredSections.value;
      console.log(filteredSections.value);
    };
    const notFull = () => {
      isFull.value;
      sectionDetailsRes.value = [];
      filteredSections.value;
      selectedSection.value = 1;

      console.log(filteredSections.value);
    };
    watch(isFull, (newVal) => {
      // Recompute the value of filteredSections
      filteredSections.value;
      console.log(filteredSections.value);
    });
    watch(isFull, (newVal) => {
      // Recompute the value of filteredSections
      filteredSections.value;
      console.log(filteredSections.value);
    });

    const register = (id, pkgid) => {
      if (sectionDetailsRes.value.sectionDetail[0].gsCodeLanguageId !== 0) {
        let msgData =
          sectionDetailsRes.value.sectionDetail[0]?.gsCodeLanguageDescr ==
          "English"
            ? translate("confirmEnglishLang")
            : translate("confirmArabicLang");
        Swal.fire({
          text: msgData,
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: translate("Submit"),
          cancelButtonText: translate("Cancel"),
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger",
            cancelButton: "btn btn-default order-1 right-gap",
          },
        }).then((confirmed) => {
          if (confirmed.isConfirmed) {
            let registeredCoursesRequest = new RegisteredCoursesRequest();
            registeredCoursesRequest.EdStudSemesterId =
              userinfo.earlyRegData.early_EdstudsemesterId;
            registeredCoursesRequest.PkgDtlId = pkgid;
            registeredCoursesRequest.EdCourseId = id;
            registeredCoursesRequest.SectionId = sceduleIdval;

            registeredCoursesRequest.invokeCourseRegister(
              app,
              (
                me: any,
                registeredCoursesResponse: RegisteredCoursesResponse
              ) => {
                if (registeredCoursesResponse.message) {
                  // debugger;
                  Swal.fire({
                    text: translate(
                      "messages." + registeredCoursesResponse.message
                    ),
                    icon: "success",
                    showConfirmButton: false,
                    color: "#716add",
                    background: "#fff ",
                    backdrop: `
                      rgba(0,0,123,0.2)
                      left top
                      no-repeat
                    `,
                    timer: 6000,
                    showClass: {
                      popup: "animate__animated animate__zoomIn",
                    },
                    hideClass: {
                      popup: "animate__animated animate__fadeOutUp",
                    },
                  });

                  setTimeout(
                    () => router.push({ name: "EarlyregisteredCourses" }),
                    4000
                  );
                }
              }
            );
          }
        });
      } else {
        let registeredCoursesRequest = new RegisteredCoursesRequest();
        registeredCoursesRequest.EdStudSemesterId =
          userinfo.earlyRegData.early_EdstudsemesterId;
        registeredCoursesRequest.PkgDtlId = pkgid;
        registeredCoursesRequest.EdCourseId = id;
        registeredCoursesRequest.SectionId = sceduleIdval;

        registeredCoursesRequest.invokeCourseRegister(
          app,
          (me: any, registeredCoursesResponse: RegisteredCoursesResponse) => {
            if (registeredCoursesResponse.message) {
              // debugger;
              Swal.fire({
                text: translate(
                  "messages." + registeredCoursesResponse.message
                ),
                icon: "success",
                showConfirmButton: false,
                color: "#716add",
                background: "#fff ",
                backdrop: `
                rgba(0,0,123,0.2)
                left top
                no-repeat
              `,
                timer: 6000,
                showClass: {
                  popup: "animate__animated animate__zoomIn",
                },
                hideClass: {
                  popup: "animate__animated animate__fadeOutUp",
                },
              });
              setTimeout(
                () => router.push({ name: "EarlyregisteredCourses" }),
                4000
              );
            }
          }
        );
      }
    };
    const addSeat = (id, pkgid) => {
      const user = localStorage.getItem("userInfo") || "";
      const res = JSON.parse(user);
      let userinfo: any = {};
      userinfo = res;
      let registeredCoursesRequest = new RegisteredCoursesRequest();

      registeredCoursesRequest.EdStudSemesterId =
        userinfo.earlyRegData.early_EdstudsemesterId;
      registeredCoursesRequest.newEntCoursePkgDtlId = pkgid;
      registeredCoursesRequest.newEdCourseId = id;
      registeredCoursesRequest.newScScheduleDtlId = sceduleIdval;
      registeredCoursesRequest.CourseChngId = 1;
      if (props.edStudCourseRegId != undefined && props.isReplace == false) {
        registeredCoursesRequest.CourseChngId = 5;
      }

      registeredCoursesRequest.invokeCourseAddSeat(
        app,
        (me: any, registeredCoursesResponse: RegisteredCoursesResponse) => {
          if (registeredCoursesResponse.message) {
            Swal.fire({
              text: translate("messages." + registeredCoursesResponse.message),
              icon: "success",
              showConfirmButton: false,
              color: "#716add",
              background: "#fff ",
              backdrop: `
                      rgba(0,0,123,0.2)
                      left top
                      no-repeat
                    `,
              timer: 6000,
              showClass: {
                popup: "animate__animated animate__zoomIn",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            });
            setTimeout(
              () => router.push({ name: "EarlyregisteredCourses" }),
              4000
            );
          }
        }
      );
    };
    const addSeatReplace = (
      edStudCourseRegId,
      scheduleDtlId,
      edStudSemesterId,
      edCourseId,
      entCoursePkgDtlId
    ) => {
      userInfoRequest.StudFacultyCode = JSON.parse(
        localStorage.getItem("user") || ""
      ).studFacultyCode;
      let registeredCoursesRequest = new RegisteredCoursesRequest();
      registeredCoursesRequest.EdStudSemesterId = edStudSemesterId;
      registeredCoursesRequest.newEntCoursePkgDtlId = entCoursePkgDtlId;
      registeredCoursesRequest.newEdCourseId = edCourseId;
      registeredCoursesRequest.newScScheduleDtlId = scheduleDtlId;
      registeredCoursesRequest.EdStudCourseRegId = edStudCourseRegId;
      registeredCoursesRequest.CourseChngId = 6;
      registeredCoursesRequest.invokeCourseAddSeat(
        app,
        (me: any, registeredCoursesResponse: RegisteredCoursesResponse) => {
          if (registeredCoursesResponse.message) {
            Swal.fire({
              text: translate("messages." + registeredCoursesResponse.message),
              icon: "success",
              showConfirmButton: false,
              color: "#716add",
              background: "#fff ",
              backdrop: `
    rgba(0,0,123,0.2)
    left top
    no-repeat
  `,
              timer: 6000,
              showClass: {
                popup: "animate__animated animate__zoomIn",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            });
            setTimeout(
              () => router.push({ name: "EarlyregisteredCourses" }),
              4000
            );
          }
        }
      );
    };
    const undrop = (regid, secid) => {
      let registeredCoursesRequest = new RegisteredCoursesRequest();
      registeredCoursesRequest.EdStudCourseRegId = regid;
      registeredCoursesRequest.ScScheduleDtlId = secid;
      registeredCoursesRequest.invokeCourseUnDrop(
        app,
        (me: any, registeredCoursesResponse: RegisteredCoursesResponse) => {
          if (registeredCoursesResponse.message) {
            Swal.fire({
              text: translate("messages." + registeredCoursesResponse.message),
              icon: "success",
              showConfirmButton: false,
              color: "#716add",
              background: "#fff ",
              backdrop: `
    rgba(0,0,123,0.2)
    left top
    no-repeat
  `,
              timer: 6000,
              showClass: {
                popup: "animate__animated animate__zoomIn",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            });

            setTimeout(
              () => router.push({ name: "EarlyregisteredCourses" }),
              4000
            );
          }
        }
      );
    };
    const replace = (
      edStudCourseRegId,
      scheduleDtlId,
      edStudSemesterId,
      edCourseId,
      entCoursePkgDtlId
    ) => {
      if (sectionDetailsRes.value.sectionDetail[0].gsCodeLanguageId !== 0) {
        let msgData =
          sectionDetailsRes.value.sectionDetail[0]?.gsCodeLanguageDescr ==
          "English"
            ? translate("confirmEnglishLang")
            : translate("confirmArabicLang");
        Swal.fire({
          text: msgData,
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: translate("Submit"),
          cancelButtonText: translate("Cancel"),
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger",
            cancelButton: "btn btn-default order-1 right-gap",
          },
        }).then((confirmed) => {
          if (confirmed.isConfirmed) {
            let registeredCoursesRequest = new RegisteredCoursesRequest();
            registeredCoursesRequest.EdStudCourseRegId = edStudCourseRegId;
            registeredCoursesRequest.ScScheduleDtlId = scheduleDtlId;
            registeredCoursesRequest.EdStudSemesterId = edStudSemesterId;
            registeredCoursesRequest.EdCourseId = edCourseId;
            registeredCoursesRequest.EntCoursePkgDtlId = entCoursePkgDtlId;

            registeredCoursesRequest.invokeCourseReplaceCourse(
              app,
              (
                me: any,
                registeredCoursesResponse: RegisteredCoursesResponse
              ) => {
                if (registeredCoursesResponse.message) {
                  Swal.fire({
                    text: registeredCoursesResponse.message,
                    icon: "success",
                    showConfirmButton: false,
                    color: "#716add",
                    background: "#fff ",
                    backdrop: `
                    rgba(0,0,123,0.2)
                    left top
                    no-repeat
              `,
                    timer: 6000,
                    showClass: {
                      popup: "animate__animated animate__zoomIn",
                    },
                    hideClass: {
                      popup: "animate__animated animate__fadeOutUp",
                    },
                  });
                  setTimeout(
                    () => router.push({ name: "EarlyregisteredCourses" }),
                    4000
                  );
                }
              }
            );
          }
        });
      } else {
        let registeredCoursesRequest = new RegisteredCoursesRequest();
        registeredCoursesRequest.EdStudCourseRegId = edStudCourseRegId;
        registeredCoursesRequest.ScScheduleDtlId = scheduleDtlId;
        registeredCoursesRequest.EdStudSemesterId = edStudSemesterId;
        registeredCoursesRequest.EdCourseId = edCourseId;
        registeredCoursesRequest.EntCoursePkgDtlId = entCoursePkgDtlId;

        registeredCoursesRequest.invokeCourseReplaceCourse(
          app,
          (me: any, registeredCoursesResponse: RegisteredCoursesResponse) => {
            if (registeredCoursesResponse.message) {
              Swal.fire({
                text: registeredCoursesResponse.message,
                icon: "success",
                showConfirmButton: false,
                color: "#716add",
                background: "#fff ",
                backdrop: `
                    rgba(0,0,123,0.2)
                    left top
                    no-repeat
              `,
                timer: 6000,
                showClass: {
                  popup: "animate__animated animate__zoomIn",
                },
                hideClass: {
                  popup: "animate__animated animate__fadeOutUp",
                },
              });
              setTimeout(
                () => router.push({ name: "EarlyregisteredCourses" }),
                4000
              );
            }
          }
        );
      }
    };
    return {
      getIllustrationsPath,
      loadSectionDetails,
      sectionDetailsRes,
      register,
      userinfo,
      courseId,
      sceduleIdval,
      isClash,
      isFull,
      edStudSemesterIdVal,
      noclash,
      notFull,
      addSeat,
      formattedDate,
      formattedDateTime,
      undrop,
      translate,
      replace,
      addSeatReplace,
      currentLanguage,
      filteredSections,
      uniqueScheduleDays,
      selectedSection,
    };
  },
});
